import { useLocation } from 'react-router-dom'
import { RouteComponentProps } from 'react-router-dom'
import { routes } from 'routes/RouterStackComponent'
import { BookType, getBookModeFromBookType } from 'store/services/Book'

export const SharedLink: React.FC<RouteComponentProps<{ bookId: string; bookType: BookType }>> = (props) => {
  const { search } = useLocation()

  const searchParams = new URLSearchParams(search)
  const bookId = searchParams.get('bookId')
  const bookType = searchParams.get('bookType')

  if (!bookId || !bookType) {
    props.history.replace(routes.home)
  }

  const bookMode = getBookModeFromBookType(bookType as BookType)

  props.history.replace(`/book/${bookMode}/${bookId}`)

  return null
}
